export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8141.9a2231eb.jpg";